export default __webpack_public_path__ + "static/media/oct2023-4.f21539ec.jpeg";